import React from "react";
import {HashLink as Link} from 'react-router-hash-link'

class Footer extends React.Component {
    render() {
        return (
            <footer className="footer">
                <div className="container">
                    <div className="footer-top">
                        <div className="footer-top__logo">
                            <img className="footer-top__logo-img" src="images/logo.png" alt=""
                                 role="presentation"/>
                        </div>
                        <div className="footer-top__contacts">
                            <h4 className="footer-top__title">Контакты
                            </h4>
                            <p className="footer-top__phone">+7 (812) 389-42-42
                            </p>
                            <p className="footer-top__mail">info@siisltd.ru
                            </p>
                        </div>
                        <div className="footer-top__address">
                            <h4 className="footer-top__title">Адрес
                            </h4>
                            <p className="footer-top__place">ул. Социалистическая, 
                                <br/>д. 14, лит. А, офис 404
                                <br/>БЦ &laquo;Овентал-History&raquo;
                                <br/>г. Санкт-Петербург, 191119
                            </p>
                        </div>
                        <ul className="footer-top__menu">
                            <li className="footer-top__item">
                                <a className="footer-top__menu-link" href="/surveystudio"><b>SURVEY</b>STUDIO</a>
                            </li>
                            <li className="footer-top__item">
                                <a className="footer-top__menu-link" href="/dex"><b>DEX</b>:DIALER EXPRESS</a>
                            </li>
                            {/* <li className="footer-top__item">
                                <a className="footer-top__menu-link" href="/ip">IP-ТЕЛЕФОНИЯ</a>
                            </li> */}
                            {/*<li className="footer-top__item">*/}
                            {/*    <a className="footer-top__menu-link" href="/#feedback">ОТЗЫВЫ</a>*/}
                            {/*</li>*/}
                            {/*<li className="footer-top__item">*/}
                            {/*    <a className="footer-top__menu-link" href="/news">НОВОСТИ</a>*/}
                            {/*</li>*/}
                            <li className="footer-top__item">
                                <a className="footer-top__menu-link" href="/#call">КОНТАКТЫ</a>
                            </li>
                        </ul>
                    </div>
                    <div className="footer-bottom">
                        <div className="footer-bottom__copy">&copy; 2023 ООО &laquo;Системы информации и связи&raquo;
                        </div>
                        <a className="telegram-bottom" href="https://t.me/s/sstdex">Мы в Telegram</a>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/Components/Footer.js